/**
 * The leaf tile bodies — every kind a `card` section can be.
 *
 * Its own module so the registry and `CardTile` both read it without
 * importing each other. Mirrors `LEAF_KINDS` in
 * `backend/omni/modules/pane/components.py` (every kind except `card`:
 * one level of composition); `Record` over that union makes a missing
 * leaf a type error.
 */
import type * as React from "react";
import type { TileBodyProps } from "../registry";
import type { TileKind } from "../types";
import { ChartTile } from "./ChartTile";
import { ChecklistTile } from "./ChecklistTile";
import { ImageTile } from "./ImageTile";
import { KpiTile } from "./KpiTile";
import { LinksTile } from "./LinksTile";
import { MarkdownTile } from "./MarkdownTile";
import { TableTile } from "./TableTile";
import { VideoTile } from "./VideoTile";

export type LeafKind = Exclude<TileKind, "card">;

export const LEAF_BODIES: Record<LeafKind, React.ComponentType<TileBodyProps>> = {
  markdown: MarkdownTile,
  kpi: KpiTile,
  table: TableTile,
  checklist: ChecklistTile,
  chart: ChartTile,
  image: ImageTile,
  video: VideoTile,
  links: LinksTile,
};
